import React, { useState, useEffect } from "react";
import "./userList.css";
import {
  Breadcrumb,
  Table,
  Image,
  Pagination,
  Switch,
  Modal,
  Input,
  message,
} from "antd";
import {
  bellIcon,
  crossIcon,
  homeIcon,
  redTrash,
  trueIcon,
  userIcon,
} from "../../assets";
import { callApi } from "../../api/apiCaller";
import routes, { BASE_URL } from "../../api/routes";
import Loader from "../../components/loader/loader";
import SearchComp from "../../components/searchCom/search";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const UserList = () => {
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState("");
  const navigate = useNavigate();
  const [isloading, setIsLoading] = useState(false);
  const [updateApi, setUpdateApi] = useState(false);
  const userData = useSelector((state) => state.userDataSlice.userData);
  const isAdmin = userData?.role === "admin";

  // Block/Unblock modal state
  const [blockModal, setBlockModal] = useState({ open: false, userId: null });
  const [blockReason, setBlockReason] = useState("");
  const [unblockModal, setUnblockModal] = useState({
    open: false,
    userId: null,
  });

  const getAllUsers = () => {
    let getRes = (res) => {
      setUsers(res?.data?.data);
    };

    callApi("GET", routes.getAllUsers, null, setIsLoading, getRes, (error) => {
      console.log("error", error);
    });
  };

  const deleteUser = (id) => {
    setUpdateApi(false);
    let getRes = (res) => {
      setUpdateApi(true);
    };

    callApi(
      "DELETE",
      `${routes.deleteUser}/${id}`,
      null,
      setIsLoading,
      getRes,
      (error) => {
        console.log("error", error);
      }
    );
  };

  const handleBlockUser = (userId) => {
    setBlockModal({ open: true, userId });
    setBlockReason("");
  };

  const handleUnblockUser = (userId) => {
    setUnblockModal({ open: true, userId });
  };

  const submitBlockUser = () => {
    if (!blockReason.trim()) {
      message.error("Block reason is required.");
      return;
    }

    setBlockModal((prev) => ({ ...prev, open: false }));

    let getRes = (res) => {
      setBlockModal({ open: false, userId: null });
      setUpdateApi((u) => !u);
      message.success("User blocked and notified.");
    };

    callApi(
      "PATCH",
      `${BASE_URL}/user/${blockModal.userId}/block-by-admin`,
      { reason: blockReason },
      setIsLoading,
      getRes,
      (error) => {
        message.error(error?.message || "Failed to block user.");
      }
    );
  };

  const submitUnblockUser = () => {
    setUnblockModal((prev) => ({ ...prev, open: false }));

    let getRes = (res) => {
      setUnblockModal({ open: false, userId: null });
      setUpdateApi((u) => !u);
      message.success("User unblocked and notified.");
    };

    callApi(
      "PATCH",
      `${BASE_URL}/user/${unblockModal.userId}/unblock-by-admin`,
      null,
      setIsLoading,
      getRes,
      (error) => {
        message.error(error?.message || "Failed to unblock user.");
      }
    );
  };

  const handleVerifyUser = (userId) => {
    let getRes = (res) => {
      setUpdateApi((u) => !u);
      message.success("User verified successfully");
    };
    callApi(
      "POST",
      `${BASE_URL}/user/admin/verify-user`,
      { userId },
      setIsLoading,
      getRes,
      (error) => {
        message.error(error?.message || "Failed to verify user.");
      }
    );
  };

  const handleUnverifyUser = (userId) => {
    let getRes = (res) => {
      setUpdateApi((u) => !u);
      message.success("User unverified successfully");
    };
    callApi(
      "POST",
      `${BASE_URL}/user/admin/unverify-user`,
      { userId },
      setIsLoading,
      getRes,
      (error) => {
        message.error(error?.message || "Failed to unverify user.");
      }
    );
  };

  useEffect(() => {
    getAllUsers();
  }, [updateApi]);

  const columns = [
    {
      title: "First Name",
      dataIndex: "firstName",
      className: "role-name-column-header",
      sorter: (a, b) => a.firstName.localeCompare(b.firstName),
    },
    {
      title: "Last Name",
      dataIndex: "lastName",
      className: "role-name-column-header",
      sorter: (a, b) => a.lastName.localeCompare(b.lastName),
      align: "center",
      width: 150,
    },

    {
      title: "Email",
      dataIndex: "email",
      align: "center",
      className: "type-name-column-header",
      sorter: (a, b) => a.email.localeCompare(b.lastName),
      width: 200,
      // filteredValue: [search],
      // onFilter: (value, record) => {
      //   return record?.email?.toLowerCase()?.includes(value.toLowerCase());
      // },
    },
    {
      title: "Phone Number",
      dataIndex: "phoneNumber",
      align: "center",
      className: "action-column-header",
    },
    {
      title: "Profile",
      dataIndex: "profile",
      align: "center",
      className: "action-column-header",
    },
    {
      title: "Verified",
      dataIndex: "verified",
      align: "center",
      className: "action-column-header",
    },
    {
      title: "Notify",
      dataIndex: "notify",
      align: "center",
      className: "action-column-header",
    },
    {
      title: "Username",
      dataIndex: "username",
      align: "center",
      className: "action-column-header",
    },
    {
      title: "Verification",
      dataIndex: "verification",
      align: "center",
      className: "action-column-header",
    },
    {
      title: "Delete",
      dataIndex: "delete",
      align: "center",
      className: "action-column-header",
    },
    {
      title: "Block",
      dataIndex: "block",
      align: "center",
      className: "action-column-header",
    },
  ];

  const data = users
    ?.filter(
      (item) =>
        item.firstName.toLowerCase().includes(search.toLowerCase()) ||
        item.lastName.toLowerCase().includes(search.toLowerCase()) ||
        item.email.toLowerCase().includes(search.toLowerCase())
    )
    ?.map((item, index) => {
      let blockUnblockBtn = null;
      let verificationBtn = null;
      if (isAdmin) {
        if (item?.isBlockedByAdmin) {
          blockUnblockBtn = (
            <div style={{ cursor: "pointer" }}>
              <button
                style={{
                  background: "#faad14",
                  color: "#fff",
                  border: "none",
                  borderRadius: 4,
                  padding: "0.5rem 1rem",
                }}
                onClick={() => handleUnblockUser(item?._id)}
              >
                Unblock
              </button>
            </div>
          );
        } else {
          blockUnblockBtn = (
            <button
              style={{
                background: "#ff4d4f",
                color: "#fff",
                border: "none",
                borderRadius: 4,
                padding: "0.5rem 1rem",
                cursor: "pointer",
              }}
              onClick={() => handleBlockUser(item?._id)}
            >
              Block
            </button>
          );
        }
        if (item?.isVerifiedByAdmin) {
          verificationBtn = (
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <span style={{ color: "#52c41a", fontWeight: 500 }}>
                Verified
              </span>
              <button
                style={{
                  background: "#faad14",
                  color: "#fff",
                  border: "none",
                  borderRadius: 4,
                  padding: "0.3rem 0.8rem",
                  cursor: "pointer",
                }}
                onClick={() => handleUnverifyUser(item?._id)}
              >
                Unverify
              </button>
            </div>
          );
        } else {
          verificationBtn = (
            <button
              style={{
                background: "#1890ff",
                color: "#fff",
                border: "none",
                borderRadius: 4,
                padding: "0.3rem 0.8rem",
                cursor: "pointer",
              }}
              onClick={() => handleVerifyUser(item?._id)}
            >
              Verify
            </button>
          );
        }
      } else {
        if (item?.isVerifiedByAdmin) {
          verificationBtn = (
            <span style={{ color: "#52c41a", fontWeight: 500 }}>Verified</span>
          );
        }
      }
      return {
        key: index,
        firstName: item?.firstName,
        lastName: item?.lastName,
        email: item?.email,
        phoneNumber: item?.number,
        profile: (
          <div className="product-list-image">
            <Image width={50} src={item?.image} alt="profile-image" />
          </div>
        ),
        verified: (
          <div>
            <img
              src={item?.verified ? trueIcon : crossIcon}
              alt=""
              style={{ width: "25px", height: "25px" }}
            />
          </div>
        ),
        notify: (
          <img
            onClick={() =>
              navigate("/pushnotification", {
                state: { userId: item?._id, email: item?.email },
              })
            }
            className="bell-notify-icon"
            src={bellIcon}
          />
        ),
        username: item?.username,
        verification: verificationBtn,
        delete: (
          <div
            style={{ cursor: "pointer" }}
            onClick={() => deleteUser(item?._id)}
          >
            <img src={redTrash} alt="" />
          </div>
        ),
        block: blockUnblockBtn,
      };
    });

  const getRowClassName = (record, index) => {
    if (index % 2 === 0) {
      return "server-role-even-row";
    }
    return "server-role-odd-row";
  };
  return (
    <div className="admin-products-main-container">
      <Loader loading={isloading} />
      {/* Block Modal */}
      <Modal
        title="Block User"
        open={blockModal.open}
        onOk={submitBlockUser}
        onCancel={() => setBlockModal({ open: false, userId: null })}
        okText="Block"
        okButtonProps={{ danger: true }}
      >
        <p>Please enter the reason for blocking this user:</p>
        <Input.TextArea
          value={blockReason}
          onChange={(e) => setBlockReason(e.target.value)}
          rows={4}
          placeholder="Enter reason (required)"
        />
      </Modal>
      {/* Unblock Modal */}
      <Modal
        title="Unblock User"
        open={unblockModal.open}
        onOk={submitUnblockUser}
        onCancel={() => setUnblockModal({ open: false, userId: null })}
        okText="Unblock"
      >
        <p>Are you sure you want to unblock this user?</p>
      </Modal>
      <Breadcrumb
        separator=">"
        className="bread-crumb"
        items={[
          {
            title: "Home",
          },
          {
            title: "Users",
          },
        ]}
      />

      <div className="configure-server-roles-main-heading-container">
        <h1>Users</h1>
      </div>
      <SearchComp
        placeHolder={"Search "}
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />
      <div className="server-roles-tb-main-container">
        <Table
          rowClassName={getRowClassName}
          columns={columns}
          dataSource={data}
          pagination={{ Pagination, pageSize: 5 }}
          className="ant-table-wrapper .ant-table-thead"
        ></Table>
      </div>
    </div>
  );
};

export default UserList;
